export default __webpack_public_path__ + "static/media/Ended.112a9d71.svg";